// import { useState } from "react";
// import {
//   searchFloorMaps,
//   getFloorMapById as fetchById,
//   createFloorMap as createApi,
//   updateFloorMap as updateApi,
//   deleteFloorMap as deleteApi,
//   publishFloorMap as publishApi,
//   uploadBackground as uploadBgApi,
//   uploadStallImage as uploadStallImageApi,
//   getStalls as getStallsApi,
//   saveStalls as saveStallsApi,
// } from "../../../api/floorMap.api";

// export const useFloorMap = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [currentMap, setCurrentMap] = useState(null);
//   const [stalls, setStalls] = useState([]);
//   const [stallsLoading, setStallsLoading] = useState(false);

//   const loadFloorMaps = async (company_id) => {
//     setLoading(true);
//     try {
//       const res = await searchFloorMaps({ company_id });
//       setData(res.data?.data || []);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadFloorMapById = async (id) => {
//     setLoading(true);
//     try {
//       const res = await fetchById(id);
//       setCurrentMap(res.data?.data || null);
//       return res.data?.data;
//     } finally {
//       setLoading(false);
//     }
//   };

//   const addFloorMap = (payload) => createApi(payload);
//   const editFloorMap = (id, payload) => updateApi(id, payload);

//   const removeFloorMap = async (id, payload) => {
//     const res = await deleteApi(id, payload);
//     return res.data;
//   };

//   const togglePublish = async (id, payload) => {
//     const res = await publishApi(id, payload);
//     return res.data;
//   };

//   const uploadFloorBackground = async (mapId, floorId, file) => {
//     const formData = new FormData();
//     formData.append("floorBackground", file);
//     const res = await uploadBgApi(mapId, floorId, formData);
//     return res.data;
//   };

//   const uploadStallImage = async (file) => {
//     const formData = new FormData();
//     formData.append("stallImage", file);
//     const res = await uploadStallImageApi(formData);
//     return res.data;
//   };

//   const loadStalls = async (floor_map_id, floor_id) => {
//     setStallsLoading(true);
//     try {
//       const res = await getStallsApi({ floor_map_id, floor_id });
//       setStalls(res.data?.data || []);
//       return res.data?.data || [];
//     } finally {
//       setStallsLoading(false);
//     }
//   };

//   const persistStalls = async (payload) => {
//     const res = await saveStallsApi(payload);
//     return res.data;
//   };

//   return {
//     data,
//     loading,
//     currentMap,
//     stalls,
//     stallsLoading,
//     loadFloorMaps,
//     loadFloorMapById,
//     addFloorMap,
//     editFloorMap,
//     removeFloorMap,
//     togglePublish,
//     uploadFloorBackground,
//     uploadStallImage,
//     loadStalls,
//     persistStalls,
//   };
// };
import { useState, useCallback } from "react";
import {
  searchFloorMaps,
  getFloorMapById as fetchById,
  createFloorMap as createApi,
  updateFloorMap as updateApi,
  deleteFloorMap as deleteApi,
  publishFloorMap as publishApi,
  uploadBackground as uploadBgApi,
  uploadStallImage as uploadStallImageApi,
  getStalls as getStallsApi,
  saveStalls as saveStallsApi,
} from "../../../api/floorMap.api";

export const useFloorMap = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentMap, setCurrentMap] = useState(null);
  const [stalls, setStalls] = useState([]);
  const [stallsLoading, setStallsLoading] = useState(false);
  const [paginationInfo, setPaginationInfo] = useState({
    totalFloorMaps: 0,
    totalPages: 1,
  });

  // Server-side paginated data fetching
  const loadFloorMaps = useCallback(async (company_id, params = {}) => {
    setLoading(true);
    try {
      const res = await searchFloorMaps({
        company_id,
        page: params.page || 1,
        limit: params.limit || 10,
        search: params.search || "",
      });

      const payload = res.data?.data || res.data || {};
      const list = payload.floorMaps || (Array.isArray(payload) ? payload : []);

      setData(list);
      setPaginationInfo({
        totalFloorMaps: payload.pagination?.totalFloorMaps || list.length,
        totalPages: payload.pagination?.totalPages || 1,
      });

      return payload;
    } catch (error) {
      console.error("Failed to fetch floor maps:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const loadFloorMapById = async (id) => {
    setLoading(true);
    try {
      const res = await fetchById(id);
      setCurrentMap(res.data?.data || null);
      return res.data?.data;
    } finally {
      setLoading(false);
    }
  };

  const addFloorMap = (payload) => createApi(payload);
  const editFloorMap = (id, payload) => updateApi(id, payload);

  const removeFloorMap = async (id, payload) => {
    const res = await deleteApi(id, payload);
    return res.data;
  };

  const togglePublish = async (id, payload) => {
    const res = await publishApi(id, payload);
    return res.data;
  };

  const uploadFloorBackground = async (mapId, floorId, file) => {
    const formData = new FormData();
    formData.append("floorBackground", file);
    const res = await uploadBgApi(mapId, floorId, formData);
    return res.data;
  };

  const uploadStallImage = async (file) => {
    const formData = new FormData();
    formData.append("stallImage", file);
    const res = await uploadStallImageApi(formData);
    return res.data;
  };

  const loadStalls = async (floor_map_id, floor_id) => {
    setStallsLoading(true);
    try {
      const res = await getStallsApi({ floor_map_id, floor_id });
      setStalls(res.data?.data || []);
      return res.data?.data || [];
    } finally {
      setStallsLoading(false);
    }
  };

  const persistStalls = async (payload) => {
    const res = await saveStallsApi(payload);
    return res.data;
  };

  return {
    data,
    loading,
    paginationInfo,
    currentMap,
    stalls,
    stallsLoading,
    loadFloorMaps,
    loadFloorMapById,
    addFloorMap,
    editFloorMap,
    removeFloorMap,
    togglePublish,
    uploadFloorBackground,
    uploadStallImage,
    loadStalls,
    persistStalls,
  };
};